import { SUPPLIER_BACKEND_API_ENDPOINTS } from "../config/apiConfig";
import { apiClient } from "./api-client.service";

import type {
  InventoryCreatePayload,
  InventoryFilter,
  InventoryMutationResponse,
  InventoryResponse,
} from "../types/inventories.types";

const endpoints = SUPPLIER_BACKEND_API_ENDPOINTS.inventory;

export const inventoriesService = {
  async list(filter: InventoryFilter): Promise<InventoryResponse> {
    try {
      const params = new URLSearchParams();
      Object.entries(filter).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== "") {
          params.set(key, String(value));
        }
      });

      return await apiClient<InventoryResponse>(endpoints.list(params.toString()), {
        method: "GET",
        isAuthenticated: true,
        cache: "no-store",
      });
    } catch (error) {
      return {
        success: false,
        statusCode: 500,
        message: error instanceof Error ? error.message : "Failed to load inventory due to an unexpected error.",
        resData: null,
      } as unknown as InventoryResponse;
    }
  },

  async create(payload: InventoryCreatePayload): Promise<InventoryMutationResponse> {
    try {
      return await apiClient<InventoryMutationResponse>(endpoints.create, {
        method: "POST",
        body: JSON.stringify(payload),
        isAuthenticated: true,
      });
    } catch (error) {
      return {
        success: false,
        statusCode: 500,
        message: error instanceof Error ? error.message : "Failed to create inventory due to an unexpected error.",
        resData: null,
      };
    }
  },
};
